import Base from "../components/layout/safeAPs/ui/Base";
import SafeAPsGridView from "../components/layout/safeAPs/ui/SafeAPsGridView";
import SafeAPRegistrationDetails from "../components/layout/safeAPs/ui/SafeAPRegistrationDetails";
import SafeAPProfile from "../components/layout/safeAPs/ui/SafeAPProfile";
import SafeAPAccount from "../components/layout/safeAPs/ui/SafeAPAccount";
import Dashboard from "../components/layout/project/Dashboard";
import ProjectGrid from "../components/layout/project/ProjectGrid";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { isExpired, decodeToken } from "react-jwt";
import { useEffect, useState } from "react";
import Login from "../components/layout/login/Login";
import { isLoggedIn } from "../utils/helpers/auth.helpers";
import TermsAndConditions from "../components/layout/login/TermsAndConditions";

function RoutesSafeAPs() {
    const Navigate = useNavigate();
    const myDecodedToken = decodeToken(localStorage.getItem("token"));
    const isMyTokenExpired = isExpired(localStorage.getItem("token"));
    const [shouldRedirectLogin, setShouldRedirectLogin] = useState(true)

    const location = useLocation()

    useEffect(() => {
        if (
            !isMyTokenExpired &&
            window.location.href !== `${process.env.REACT_APP_BASE_URL}`
        ) {
            sessionStorage.setItem("id", myDecodedToken.user.id);
            sessionStorage.setItem("name", myDecodedToken.user.fullName.first);
        }
    }, []);

    useEffect(() => {

        if (
            location.pathname !== `/` &&
            location.pathname !== `/registration` &&
            location.pathname !== `/forgotPassword` &&
            location.pathname !==`/termsAndConditions`&&
            location.pathname !==`/2faPage`&&
            // location.pathname !==`/createBestPractice`&&
            !location.pathname.includes(`/projectInvite`)&&
            !location.pathname.includes(`/directory`)&&
            !location.pathname.includes(`/passwordReset`)&&
            !location.pathname.includes(`/publicClientQuestionnaire`)
        ) {
            // setShouldRedirectLogin(true)
            // setShouldRedirectLogin(true)

            isLoggedIn(setShouldRedirectLogin)
        }
    });

    // console.log(location.pathname)
    // console.log(isLoggedIn())
    useEffect(() => {
        if (!shouldRedirectLogin) {
            // console.log("Hello")
            console.log("window: ", window.location.href);
            console.log("process", process.env.REACT_APP_BASE_URL);
            Navigate("/");
        }
    }, [shouldRedirectLogin])


    return (
        <Routes>
            {/* <Route exact path="/" element={<Login />} /> */}
            {/* <Route exact path="/termsAndConditions" element={<TermsAndConditions />} /> */}

            <Route path="/safeAPs/profile/:id" element={<Dashboard />}>
                <Route index element={<SafeAPProfile />} />
            </Route>

            <Route path="/safeAPs/account/:id" element={<Dashboard />}>
                <Route index element={<SafeAPAccount />} />
            </Route>

            <Route path="/safeAPs" element={<Dashboard />}>
                <Route index element={<SafeAPsGridView />} />
            </Route>

            <Route
                exact
                path="/safeAPs/pending/:id"
                element={
                    <Base adminView={true} mainContent={<SafeAPRegistrationDetails />} />
                }
            />
            <Route path="/safeAPs/profile/edit/:id" element={<Dashboard />}>
                <Route index element={<SafeAPRegistrationDetails />} />
            </Route>
            {/* <Route
        exact
        path="/safeAPs/profile/edit/:id"
        element={
          <Base adminView={true} mainContent={<SafeAPRegistrationDetails />} />
        }
      /> */}
        </Routes>
    );
}

export default RoutesSafeAPs;
